import React, {Component} from "react";

import axios from 'axios';
import AuthStore from '../../stores/AuthStore';
import Mousetrap from 'mousetrap';
import ReactTooltip from 'react-tooltip'

import {
  Badge,
  Row,
  Col,
  Button,
  ButtonGroup,
  Label,
  Input,
  Table,
  TabContent,

  Collapse, ListGroup, ListGroupItem,
  TabPane,
  Nav, NavItem, NavLink
} from "reactstrap";

import Constants from '../../components/Constants';
import classnames from "classnames";


class DiagnosticSelect extends Component {

    constructor(props) {
        super(props);

        this.toggleDiagTab = this.toggleDiagTab.bind(this);
        this.toggleCollapsible = this.toggleCollapsible.bind(this);

        this.getPrevCategory = this.getPrevCategory.bind(this);
        this.getNextCategory = this.getNextCategory.bind(this);
        this.isChildrenSelected = this.isChildrenSelected.bind(this);
        this.isDiagnosticSelected = this.isDiagnosticSelected.bind(this);
        this.selectDiagAt = this.selectDiagAt.bind(this);
        this.closeAllCollapsible = this.closeAllCollapsible.bind(this);
        this.markActualCategoryAsNonApplicable = this.markActualCategoryAsNonApplicable.bind(this);
        this.selectDiagNode = this.selectDiagNode.bind(this);
        this.getDiagById = this.getDiagById.bind(this);

        this._goNext = this._goNext.bind(this);
        this._goPrev = this._goPrev.bind(this);

        this.state = {
            activeDiagTab: '1',
            activeCollapsible: null,
            categories: null,

            categoryApplicability: null,
            collapse: null,
            activeDiagCollapsible: null,
            nodeSelected: null
        };
    }

    compareFullCategory(a,b) {
      if (a.category.order < b.category.order)
        return -1;
      if (a.category.order > b.category.order)
        return 1;
      return 0;
    }

    componentDidMount(){

      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/category/full/1/'+this.props.examType+'/'+this.props.clientId
      })
      .then(response => {
        let fullCategories =  response.data;

        fullCategories = fullCategories.filter(category => category.diags && category.diags.length > 0);

        fullCategories = fullCategories.sort(this.compareFullCategory);

        let categoryApplicability = {};
        for(let i = 0; i < fullCategories.length; i++) {
          if(this.props.selectedByDefault){

            if(this.props.checkCategoryEmpty(fullCategories[i].category.id)){
              categoryApplicability[fullCategories[i].category.id] = true;
            }

          }else{
            categoryApplicability[fullCategories[i].category.id] = false;
          }
        }

        this.setState({
          categories: fullCategories,
          activeDiagTab: response.data[0].category.id,
          activeCollapsible: response.data[0].category.id,

          categoryApplicability: categoryApplicability
        });

      });

      //atalhos de teclado

      Mousetrap.bind(['down'], (e)=>{
        if (e.preventDefault) {
            e.preventDefault();
        } else {
            // internet explorer
            e.returnValue = false;
        }
        this._goNext();
      });



      Mousetrap.bind(['up'], (e)=>{
        if (e.preventDefault) {
            e.preventDefault();
        } else {
            // internet explorer
            e.returnValue = false;
        }
        this._goPrev();
      });
    }

    _goNext(){
      if(this.getNextCategory() != -1)
      this.toggleDiagTab(this.getNextCategory());
    }

    _goPrev(){
      if(this.getPrevCategory() != -1)
      this.toggleDiagTab(this.getPrevCategory());
    }

    getNextCategory(){
      for(let i = 0; i < this.state.categories.length; i++) {
        if(this.state.categories[i].category.id === this.state.activeDiagTab) {
            if(i+1 >= this.state.categories.length) return -1;
            return this.state.categories[i+1].category.id;
        }
      }

      return -1;
    }

    getPrevCategory(){
      for(let i = 0; i < this.state.categories.length; i++) {
        if(this.state.categories[i].category.id === this.state.activeDiagTab) {
            if(i-1 < 0) return -1;
            return this.state.categories[i-1].category.id;
        }
      }

      return -1;
    }

    isChildrenSelected(diagNode){
      if( this.props.diagnostics == null) return false;
      for(let i = 0; i < diagNode.children.length; i++) {
          if(this.props.diagnostics.indexOf(diagNode.children[i].diagnostic) != -1){
            return true;
          }
      }

      return false;
    }

    selectDiagAt(categoryId, index){
      //TODO MULTIDIAG ???.

      index--;
      for(let i = 0; i < this.state.categories.length; i++) {
        if(this.state.categories[i].category.id == categoryId){

          let actualCategory = this.state.categories[i];
          if(actualCategory.diags.length > index){

            let actualDiag = actualCategory.diags[index];
            this.selectDiagNode(actualDiag, actualCategory);
          }else{
            console.log("NO DIAGS IN THIS INDEX : "+index);
            //Não existe diagnóstico neste index;
          }
        }
    }

      return false;
    }

    selectDiagNode(diag, category){      
      diag.category.allowMultipleDiag = category.allowMultipleDiag;
      //Adiciona diagnóstico
      diag.category.order = category.order;
      this.props.onDiagnosticSelect(diag);
		
      //Remove a seleção (se houver) do Diagnóstico Não-Aplicável
      let categoryApplicability = this.state.categoryApplicability;
      categoryApplicability[diag.category.id] = false;
	  
      this.setState({'categoryApplicability': categoryApplicability, 'nodeSelected': null, 'activeDiagCollapsible': null});
      
      if(!category.allowMultipleDiag){
        setTimeout(function(){
          Mousetrap.trigger("down");
        }, 100);
      }
    }

    componentWillUnmount(){
      Mousetrap.reset();
    }

    isDiagnosticSelected(diagId){
      if( this.props.diagnostics == null) return false;
      for(let i = 0; i < this.props.diagnostics.length; i++) {
          if(this.props.diagnostics[i].id == diagId){
            return true;
          }
      }

      return false;
    }
	
	getDiagById(diagId, diags){
      if( diags == null) return null;
      for(let i = 0; i < diags.length-1; i++) {
          if(diags[i].id == diagId){
            return diags[i];
          }
      }

      return null;
    }

    toggleDiagTab(tab) {
        if (this.state.activeDiagTab !== tab) {
          this.setState({
            activeDiagTab: tab
          });
        }
    }

    closeAllCollapsible(){
      let collapse = this.state.collapse;

      for(let i = 0; i < this.state.categories.length; i++) {
        for(let j = 0; j < this.state.categories[i].diagNodes.length; j++) {
          if(this.state.categories[i].diagNodes[j].children.length > 1){
            collapse[this.state.categories[i].category.id+"-"+this.state.categories[i].diagNodes[j].text] = false;
          }
        }
      }

      this.setState({"collapse": collapse});
    }

    toggleCollapsible(collapsible) {
      let collapse = this.state.collapse;
      let newValue = !this.state.collapse[collapsible];

      for(let i = 0; i < this.state.categories.length; i++) {
        for(let j = 0; j < this.state.categories[i].diagNodes.length; j++) {
          if(this.state.categories[i].diagNodes[j].children.length > 1){
            collapse[this.state.categories[i].category.id+"-"+this.state.categories[i].diagNodes[j].text] = false;
          }
        }
      }

      setTimeout(function(){
        collapse[collapsible] = newValue;
        this.setState({"collapse": collapse, "activeDiagCollapsible": (newValue ? collapsible : null) });

      }.bind(this), 100);
    }

    markActualCategoryAsNonApplicable(){
      //TODO remover os diagnósticos selecionados desta categoria.

      for(let i = 0; i < this.props.diagnostics.length; i++) {
          let diagnosticsProps = this.props.diagnostics;
          if(this.props.diagnostics[i].category.id == this.state.activeDiagTab){
            diagnosticsProps.splice(i, 1);
          }
      }

      let categoryApplicability = this.state.categoryApplicability;
      categoryApplicability[this.state.activeDiagTab] = !categoryApplicability[this.state.activeDiagTab];
      this.setState({'categoryApplicability': categoryApplicability});

      setTimeout(function(){Mousetrap.trigger("down");}, 100);
      this.props.checkReportComplete();
	    this.props.onReportChange();
    }

    render() {
        var shortcuts = {
          0: "0",
          1: "1",
          2: "2",
          3: "3",
          4: "4",
          5: "5",
          6: "6",
          7: "7",
          8: "8",
          9: "9",
          10: "alt+1",
          11: "alt+2",
          12: "alt+3",
          13: "alt+4",
          14: "alt+5",
          15: "alt+6",
          16: "alt+7",
          17: "alt+8",
          18: "alt+9",
          19: "alt+0"
        };
        var categoryNav = [];
        var categoryTab = [];
        var index = 0;

        if(this.state.categories == null) return null;

        let tabPane = document.querySelector(".diagnostic-select-panel");

        Mousetrap(tabPane).bind('0', (e)=>{
          this.markActualCategoryAsNonApplicable();
        });

        Mousetrap(tabPane).bind('1', (e)=>{
          console.log(this.state.activeDiagTab)
          this.selectDiagAt(this.state.activeDiagTab, 1);
        });
        Mousetrap(tabPane).bind('2', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 2);
        });
        Mousetrap(tabPane).bind('3', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 3);
        });
        Mousetrap(tabPane).bind('4', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 4);
        });
        Mousetrap(tabPane).bind('5', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 5);
        });
        Mousetrap(tabPane).bind('6', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 6);
        });
        Mousetrap(tabPane).bind('7', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 7);
        });
        Mousetrap(tabPane).bind('8', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 8);
        });
        Mousetrap(tabPane).bind('9', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 9);
        });
        Mousetrap(tabPane).bind('alt+1', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 10);
        });
        Mousetrap(tabPane).bind('alt+2', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 11);
        });
        Mousetrap(tabPane).bind('alt+3', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 12);
        });
        Mousetrap(tabPane).bind('alt+4', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 13);
        });
        Mousetrap(tabPane).bind('alt+5', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 14);
        });
        Mousetrap(tabPane).bind('alt+6', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 15);
        });
        Mousetrap(tabPane).bind('alt+7', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 16);
        });
        Mousetrap(tabPane).bind('alt+8', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 17);
        });
        Mousetrap(tabPane).bind('alt+9', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 18);
        });
        Mousetrap(tabPane).bind('alt+0', (e)=>{
          this.selectDiagAt(this.state.activeDiagTab, 19);
        });

        this.state.categories.forEach(function(fullCategory) {
            let category = fullCategory.category;
            let diags = fullCategory.diags;
			
            categoryNav.push(
              <NavItem className={this.state.activeDiagTab == category.id ? "active" : ""} key={"category-"+category.id}>
                <NavLink
                  onClick={() => { this.toggleDiagTab(category.id); }}>
                  {category.description}
                  {
                    !this.props.checkCategoryEmpty(category.id) || this.state.categoryApplicability[category.id] ?
                    <Badge color="success" className="float-right"><i className="fa fa-check"></i></Badge>
                    : ''
                  }
				  <br />
				  <small data-tip={this.getDiagById(category.normalDiagId, diags) == null ? "Não Aplicável" : 
							this.getDiagById(category.normalDiagId, diags).details}
							>{this.getDiagById(category.normalDiagId, diags) == null ? "Não Aplicável" : 
							this.getDiagById(category.normalDiagId, diags).description}</small>
                </NavLink>
              </NavItem>
            );


            //Cria os diagnósticos da Categoria.
            var diagItens = [];

            //Cria o Diagnóstico 0 - Não Aplicável
            diagItens.push(
              <ListGroupItem className={this.state.categoryApplicability[category.id] ? "active" : ""} key={category.id+"-not-applicable"}
                onClick={() => {
                  this.markActualCategoryAsNonApplicable();
                }}
				data-tip={"Não Aplicável"}
				>

                <div className="shortcut-description">[0]</div>
                {" Não Aplicável"}
              </ListGroupItem>
            );

            index = 1;
            diags.forEach(function(diag) {
              diagItens.push(
                <ListGroupItem key={"list-item-"+diag.id}
                  onClick={() => { this.selectDiagNode(diag, category); }}
                  data-tip={diag.details}
                  className={this.isDiagnosticSelected(diag.id) ? "active" : ""}>
                  {index <= 19 ? <div className="shortcut-description">[{shortcuts[index]}]</div> : ''}
                  {"  "+diag.description}
                </ListGroupItem>
              );

              index++;
            }, this);

            categoryTab.push(
              <TabPane tabId={category.id} key={"tab-"+category.id} id={"tab-"+category.id}>
                <ListGroup className="diagnostic-list">
                  {diagItens}
                </ListGroup>
              </TabPane>
            );

        }.bind(this));

        return (
          <div>
            <Row className="diagnostic-select-panel">
              <Col md="5" sm="12">
                <Nav vertical tabs  className="category-list">
                  {categoryNav}
                </Nav>
              </Col>
              <Col md="7" sm="12">
                <TabContent activeTab={this.state.activeDiagTab}>
                  {categoryTab}
                </TabContent>
              </Col>
            </Row>
			<ReactTooltip />
          </div>
        )
    }
}

export default DiagnosticSelect;



// WEBPACK FOOTER //
// ./src/views/DiagnosticSelect/DiagnosticSelect.js